import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {
  VarianteDePrecoDeItemDTO,
  GrupoDeModificadorDePrecoDeItemDTO,
  ModificadorDePrecoDeItemDTO,
} from '../../models/produto-variante-modificador/produto-variante-modificador.model';

@Injectable({
  providedIn: 'root',
})
export class ProdutoVarianteModificadorService {
  constructor(private apiService: ApiService) {}

  // ========== Variantes de Preco ==========

  getVariantes(itemId: number): Observable<VarianteDePrecoDeItemDTO[]> {
    return this.apiService.read<VarianteDePrecoDeItemDTO[]>(
      `/varianteDePrecoDeItem?itemId=${itemId}`
    );
  }

  createVariante(data: VarianteDePrecoDeItemDTO): Observable<VarianteDePrecoDeItemDTO> {
    return this.apiService.create<VarianteDePrecoDeItemDTO>('/varianteDePrecoDeItem', data);
  }

  updateVariante(id: number, data: VarianteDePrecoDeItemDTO): Observable<VarianteDePrecoDeItemDTO> {
    return this.apiService.update<VarianteDePrecoDeItemDTO>(`/varianteDePrecoDeItem/${id}`, data);
  }

  deleteVariante(id: number): Observable<any> {
    return this.apiService.delete(`/varianteDePrecoDeItem/${id}`);
  }

  // ========== Grupos de Modificadores ==========

  getGrupos(itemId: number): Observable<GrupoDeModificadorDePrecoDeItemDTO[]> {
    return this.apiService.read<GrupoDeModificadorDePrecoDeItemDTO[]>(
      `/grupoDeModificadorDePrecoDeItem?itemId=${itemId}`
    );
  }

  createGrupo(data: GrupoDeModificadorDePrecoDeItemDTO): Observable<GrupoDeModificadorDePrecoDeItemDTO> {
    return this.apiService.create<GrupoDeModificadorDePrecoDeItemDTO>('/grupoDeModificadorDePrecoDeItem', data);
  }

  updateGrupo(id: number, data: GrupoDeModificadorDePrecoDeItemDTO): Observable<GrupoDeModificadorDePrecoDeItemDTO> {
    return this.apiService.update<GrupoDeModificadorDePrecoDeItemDTO>(`/grupoDeModificadorDePrecoDeItem/${id}`, data);
  }

  deleteGrupo(id: number): Observable<any> {
    return this.apiService.delete(`/grupoDeModificadorDePrecoDeItem/${id}`);
  }

  // ========== Modificadores (opcoes dentro de um grupo) ==========

  createModificador(data: ModificadorDePrecoDeItemDTO): Observable<ModificadorDePrecoDeItemDTO> {
    return this.apiService.create<ModificadorDePrecoDeItemDTO>('/modificadorDePrecoDeItem', data);
  }

  updateModificador(id: number, data: ModificadorDePrecoDeItemDTO): Observable<ModificadorDePrecoDeItemDTO> {
    return this.apiService.update<ModificadorDePrecoDeItemDTO>(`/modificadorDePrecoDeItem/${id}`, data);
  }

  deleteModificador(id: number): Observable<any> {
    return this.apiService.delete(`/modificadorDePrecoDeItem/${id}`);
  }
}
